const MissingCoordinatesCard = ({ properties, errorMessage }) => {
  return (
    <section className="panel-card admin-re-quality-card">
      <p className="eyebrow">Unmapped listings</p>
      <h3>Missing coordinates</h3>
      <p className="muted admin-re-quality-note">
        Unmapped properties may appear in listing results but do not appear on the map.
      </p>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

      {!errorMessage && !properties?.length ? (
        <p className="muted">No unmapped properties in this sample.</p>
      ) : null}

      {!errorMessage && properties?.length ? (
        <ul className="admin-re-quality-list">
          {properties.map((property) => (
            <li key={property.id}>
              <strong>{property.title}</strong>
              <span>
                {property.displaySource || property.sourceCode}
                {property.price !== null ? ` · ${property.currencyCode} ${property.price}` : ""}
                {property.city ? ` · ${property.city}` : ""}
              </span>
              {property.sourceUrl ? (
                <a href={property.sourceUrl} target="_blank" rel="noreferrer">
                  View source listing
                </a>
              ) : null}
              <span className="muted">Last seen: {property.lastSeenAt || "—"}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default MissingCoordinatesCard;
